export const formatLocalDate = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(date.getDate()).padStart(2, "0")}`;

// 日历显示的是本地日期，直接发送日期字符串，避免 UTC 转换造成跨日。
export const buildDetectionDateRange = (mode, value) => {
  if (!value || (Array.isArray(value) && value.length !== 2)) return {};
  if (mode === "range") return { startDate: value[0], endDate: value[1] };
  const year = Number(value.slice(0, 4));
  if (mode === "year") {
    return { startDate: `${year}-01-01`, endDate: `${year}-12-31` };
  }
  if (mode === "month") {
    const month = Number(value.slice(5, 7));
    return {
      startDate: `${value.slice(0, 7)}-01`,
      endDate: formatLocalDate(new Date(year, month, 0)),
    };
  }
  return { startDate: value, endDate: value };
};
